export default __webpack_public_path__ + "static/perforated-d96fd4736591b11a193ccd8c536fd25a.jpg";